document.addEventListener('DOMContentLoaded', function(){
  const audioRuUrl = 'https://cdn.shopify.com/s/files/1/0619/0163/5807/files/varvikas.mp3';
  const audioEtUrl = 'https://cdn.shopify.com/s/files/1/0619/0163/5807/files/varvikas_-_mul_on_lubatud_olla_leebem.mp3';

  const $ = id => document.getElementById(id);
  const audio = $('vp-audio');
  const btnPlay = $('vp-play');
  const range = $('vp-range');
  const cur = $('vp-current');
  const dur = $('vp-duration');
  const langRu = $('lang-ru');
  const langEt = $('lang-et');

  let state = { lang: 'ru' };

  function fmtTime(s){
    if (!isFinite(s)) return '00:00';
    const m = Math.floor(s/60);
    const sec = Math.floor(s%60);
    return String(m).padStart(2,'0') + ':' + String(sec).padStart(2,'0');
  }

  function setLang(l){
    state.lang = l === 'et' ? 'et' : 'ru';
    const src = state.lang === 'ru' ? audioRuUrl : audioEtUrl;
    if (audio) { audio.src = src; audio.load(); }
    if (btnPlay) btnPlay.textContent = (audio && !audio.paused) ? ((state.lang==='ru')?'Пауза':'Peata') : ((state.lang==='ru')?'Включить медитацию':'Lülita meditatsioon sisse');
    langRu?.classList.toggle('active', state.lang==='ru');
    langEt?.classList.toggle('active', state.lang==='et');
  }

  (function preselect(){ try { const p = new URLSearchParams(window.location.search); const l = p.get('lang'); if (l === 'et' || l === 'ru') setLang(l); else setLang('ru'); } catch(e){ setLang('ru'); } })();

  btnPlay?.addEventListener('click', function(){ if (!audio) return; if (audio.paused) audio.play(); else audio.pause(); });
  audio?.addEventListener('play', ()=> { btnPlay?.setAttribute('aria-pressed','true'); if (btnPlay) btnPlay.textContent = (state.lang==='ru')?'Пауза':'Peata'; });
  audio?.addEventListener('pause', ()=> { btnPlay?.setAttribute('aria-pressed','false'); if (btnPlay) btnPlay.textContent = (state.lang==='ru')?'Включить медитацию':'Lülita meditatsioon sisse'; });

  audio?.addEventListener('timeupdate', function(){
    if (!isNaN(audio.duration) && audio.duration > 0){ const pct = (audio.currentTime / audio.duration) * 100; range && (range.value = pct); cur && (cur.textContent = fmtTime(audio.currentTime)); dur && (dur.textContent = fmtTime(audio.duration)); }
  });
  audio?.addEventListener('loadedmetadata', ()=> dur && (dur.textContent = fmtTime(audio.duration || 0)));

  range?.addEventListener('input', function(e){ if (!audio || isNaN(audio.duration)) return; const t = (Number(e.target.value)/100) * audio.duration; cur && (cur.textContent = fmtTime(t)); });
  range?.addEventListener('change', function(e){ if (!audio || isNaN(audio.duration)) return; audio.currentTime = (Number(e.target.value)/100) * audio.duration; });

  langRu?.addEventListener('click', ()=> setLang('ru'));
  langEt?.addEventListener('click', ()=> setLang('et'));
});